module.exports = "/out/38c3077e588943036fc21521290e52ed.png";